<template>
  <div class="mainContainer" v-loading="pageLoading">
    <div class="nav">
      <div class="navContainer" style="width: 210px">
        <p>委托商：</p>
        <el-input v-model="companyIpt" size="mini" style="width: 150px" placeholder="请输入委托商名称" />
      </div>
      <div class="navContainer">
        <p>类型：</p>
        <el-select v-model="customerIpt" filterable size="mini" style="width: 150px" placeholder="请选择">
          <el-option v-for="item in customerOption2" :key="item.id" :label="item.type_name" :value="item.id" />
        </el-select>
      </div>
      <div class="navContainer" style="width: 230px">
        <p>公司性质：</p>
        <el-select v-model="enterpriseIpt" filterable size="mini" style="width: 150px" placeholder="请选择">
          <el-option v-for="item in enterpriseOption" :key="item.id" :label="item.classaName" :value="item.id" />
        </el-select>
      </div>
      <div class="navContainer">
        <p>状态：</p>
        <el-select v-model="stateIpt" filterable size="mini" style="width: 150px" placeholder="请选择">
          <el-option v-for="item in stateOption" :key="item.label" :label="item.label" :value="item.value" />
        </el-select>
      </div>
      <div class="navBtn">
        <el-button size="small" class="searchBtn" @click="searchBtn">查询</el-button>
        <el-button size="small" class="resetBtn" @click="resetBtn">重置</el-button>
        <el-button size="small" type="primary" @click="addBtn">新增</el-button>
        <el-button size="small" type="primary" @click="synchronize">同步</el-button>
      </div>
    </div>
    <div class="content">
      <div class="tableContainer">
        <div class="tableContainerNav">
          <span class="el-icon-download el-icon--right" style="cursor: pointer; font-size: 16px; margin-right: 20px; color: rgba(51, 136, 255, 1); display: flex; align-items: center" @click="download">模板下载</span>
          <span @click="exportClick" style="cursor: pointer; font-size: 16px">导出数据</span>
          <!-- <batchImport :upload-url="importUrl" @importSuccess="importSuccess" style="font-size: 16px"></batchImport> -->
          <span style="cursor: pointer">
            <el-upload ref="upload" class="upload-demo" :action="importUrl" :auto-upload="true" :show-file-list="false" :data="uploadData1" :on-success="planOnSuccess" :before-upload="beforeUpload">
              <i class="el-icon-upload el-icon--right">批量导入</i>
            </el-upload>
          </span>
        </div>
        <el-table v-loading="tableLoad" :data="TableDatas" style="width: 100%" border stripe :header-cell-style="{ color: '#3B3B3B', 'font-size': '13px', height: '48px', background: '#E8E8E8' }" :cell-style="{ color: '#7F7F7F', 'font-size': '13px', height: '52px' }" :row-class-name="tableRowClassName">
          <el-table-column label="序号" align="center" width="50px">
            <template slot-scope="scope">
              <el-badge value="危" class="item" :hidden="!scope.row.isRisky">
                <div style="height: 18px">
                  {{ tableIndexMethod(scope.$index) }}
                </div>
              </el-badge>
            </template>
          </el-table-column>
          <el-table-column prop="customerName" label="委托商全称" align="center" width="210" />
          <el-table-column prop="customerSimple" label="委托商简称" align="center" width="190" />
          <el-table-column prop="typeName" label="类型" align="center" width="130">
            <template slot-scope="scope">
              <div style="overflow: hidden; white-space: nowrap; text-overflow: ellipsis">
                <span v-for="(item, index) in scope.row.type">{{ item }}<span v-if="index !== scope.row.type.length - 1">、</span></span>
              </div>
            </template>
          </el-table-column>
          <!--          <el-table-column prop="customerNatureName" label="公司性质" align="center"/>-->
          <el-table-column prop="telephone" label="联系电话" align="center" />
          <!--          <el-table-column prop="address" label="详细地址" align="center" width="190" show-overflow-tooltip/>-->
          <el-table-column label="状态" align="center" width="100">
            <div slot-scope="scope">{{ getState(scope.row.status) }}</div>
          </el-table-column>
          <el-table-column label="操作" :width="operationWidth" align="center">
            <template slot-scope="scope">
              <div style="display: flex; align-items: center; padding-left: 10px" class="dynamicWidth">
                <el-button size="mini" class="searchBtn" type="primary" @click="detailClick(scope.row.id)">详情 </el-button>
                <el-button size="mini" type="primary" @click="editBtn(scope.row.id)" class="yellow-bg">修改 </el-button>
                <el-button v-if="scope.row.status == 1" size="mini" type="primary" @click="basicInfoClick(scope.row)" class="yellow-bg">修改基础信息 </el-button>
                <el-button v-if="scope.row.status == 1" size="mini" type="primary" @click="changeClick(scope.row)" class="yellow-bg">信息变更 </el-button>
                <el-button v-if="scope.row.status == 0" class="resetBtn" size="mini" @click="disableClick(scope.$index, scope.row)">取消审核 </el-button>
                <el-button v-if="scope.row.status == 1" size="mini" type="danger" @click="enableClick(scope.row.id)">终止合作 </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="paginationContainer">
        <span>共{{ total }}条</span>
        <el-pagination background :page-sizes="[10, 20, 30, 40]" layout="sizes,prev, pager, next,jumper" :total="total" @size-change="contractSizeChange" @current-change="contractCurrentChange" @prev-click="contractCurrentChange" @next-click="contractCurrentChange" />
      </div>
    </div>
    <transition name="el-fade-in-linear">
      <popup :title="dialogTitle" :show.sync="dialogVisible" width="700" center @close="dialogClose" :close-on-click-modal="false">
        <el-row class="depart">
          <el-form :model="companyData" label-width="120px" :rules="rules" ref="ruleForm" size="medium" v-loading="formLoading">
            <div-border label="基础信息" divStyle="margin-top: 10px">
              <el-row>
                <el-col>
                  <el-form-item label="委托商全称：" prop="company" style="margin-top: 15px">
                    <el-input :style="'width:100%'" v-model="companyData.company" placeholder="请输入委托商全称" autocomplete="off" size="mini" />
                  </el-form-item>
                </el-col>
                <el-col>
                  <el-form-item label="委托商简称：" prop="referred">
                    <el-input :style="'width:100%'" v-model="companyData.referred" placeholder="请输入委托商名称" autocomplete="off" size="mini" />
                  </el-form-item>
                </el-col>
                <el-col v-if="dialogTitle === '新增委托商' || dialogTitle === '修改委托商'">
                  <el-form-item label="关键词：" prop="keyword">
                    <el-input :style="'width:100%'" v-model="companyData.keyword" placeholder="请输入委托商关键词" autocomplete="off" size="mini" />
                  </el-form-item>
                </el-col>
                <el-col>
                  <el-form-item label="客户类型：" prop="customer">
                    <el-cascader
                      size="mini"
                      v-model="companyData.customer"
                      class="specialSelect"
                      :options="customerOption"
                      style="width: 100%"
                      clearable
                      filterable
                      :props="{
                        multiple: true,
                        checkStrictly: false,
                        emitPath: false,
                        value: 'id',
                        label: 'type_name',
                      }" />
                  </el-form-item>
                </el-col>
                <el-col>
                  <el-form-item label="是否危险客户：" prop="danger" size="mini" v-if="dialogTitle === '信息变更'">
                    <el-radio v-model="companyData.danger" :label="1">是</el-radio>
                    <el-radio v-model="companyData.danger" :label="0">否</el-radio>
                  </el-form-item>
                </el-col>
                <el-col :span="12" v-if="dialogTitle === '新增委托商' || dialogTitle === '修改委托商'">
                  <!--                  prop="nature"-->
                  <el-form-item label="公司性质：">
                    <el-select v-model="companyData.nature" filterable size="mini" style="width: 100%" placeholder="请输入公司性质" value-key="id">
                      <el-option v-for="item in enterpriseOption2" :key="item.id" :label="item.attrNm" :value="item" />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12" v-if="dialogTitle === '新增委托商' || dialogTitle === '修改委托商'">
                  <el-form-item label="公司规模：">
                    <el-select v-model="companyData.size" filterable size="mini" style="width: 100%" placeholder="请输入公司规模" value-key="id">
                      <el-option v-for="item in sizeOption" :key="item.id" :label="item.attrNm" :value="item" />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12" v-if="dialogTitle === '新增委托商' || dialogTitle === '修改委托商'">
                  <el-form-item label="经营范围：">
                    <el-input :style="'width:100%'" v-model="companyData.scope" placeholder="请输入经营范围" autocomplete="off" size="mini" />
                  </el-form-item>
                </el-col>
                <el-col :span="12" v-if="dialogTitle === '新增委托商' || dialogTitle === '修改委托商'">
                  <el-form-item label="注册资金：">
                    <el-input :style="'width:100%'" v-model="companyData.registered" placeholder="请输入注册资金" autocomplete="off" size="mini" />
                  </el-form-item>
                </el-col>
                <el-col :span="12" v-if="dialogTitle === '新增委托商' || dialogTitle === '修改委托商'">
                  <el-form-item label="联系电话：" prop="cTell">
                    <el-input :style="'width:100%'" v-model="companyData.cTell" placeholder="请输入委托商联系电话" autocomplete="off" size="mini" />
                  </el-form-item>
                </el-col>
                <el-col :span="12" v-if="dialogTitle === '新增委托商' || dialogTitle === '修改委托商'">
                  <el-form-item label="联系邮箱：" prop="mail">
                    <el-input :style="'width:100%'" v-model="companyData.mail" placeholder="请输入委托商联系邮箱" autocomplete="off" size="mini" />
                  </el-form-item>
                </el-col>
                <el-col v-if="dialogTitle === '新增委托商' || dialogTitle === '修改委托商'">
                  <!--                  <el-form-item label="详细地址：" prop="address">-->
                  <!--                    <div style="display: flex;cursor: pointer;align-items: center;" @click="mapVisible=true">-->
                  <!--                      <el-input-->
                  <!--                        :disabled="true"-->
                  <!--                        style="width:90%;margin-right: 10px;"-->
                  <!--                        :style="'width:100%'"-->
                  <!--                        v-model="companyData.address"-->
                  <!--                        placeholder="请输入详细地址"-->
                  <!--                        autocomplete="off"-->
                  <!--                        size="mini"-->
                  <!--                      />-->
                  <!--                      <i class="el-icon-location"/>-->
                  <!--                    </div>-->
                  <!--                  </el-form-item>-->
                </el-col>
                <el-col :span="12">
                  <el-form-item label="纳税号：" prop="sellerTaxno">
                    <el-input :style="'width:100%'" v-model="companyData.sellerTaxno" placeholder="请输入纳税号" autocomplete="off" size="mini" />
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="开户行：" prop="bank">
                    <el-input :style="'width:100%'" v-model="companyData.bank" placeholder="请输入公司开户行" autocomplete="off" size="mini" />
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="公司银行卡号：" prop="bankNo">
                    <el-input :style="'width:100%'" v-model="companyData.bankNo" placeholder="请输入公司银行卡号" autocomplete="off" size="mini" />
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="业务来源：" prop="businessSourceId">
                    <el-select v-model="companyData.businessSourceId" filterable size="mini" style="width: 100%" placeholder="请选择业务来源" value-key="id">
                      <el-option v-for="item in selectedData.attrList" :key="item.id" :label="item.classaName" :value="item.id" />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="客户行业：" prop="customerIndustryId">
                    <el-select v-model="companyData.customerIndustryId" filterable size="mini" style="width: 100%" placeholder="请选择客户行业" value-key="id">
                      <el-option v-for="item in selectedData.attrList2" :key="item.id" :label="item.classaName" :value="item.id" />
                    </el-select>
                  </el-form-item>
                </el-col>
                <div v-for="(item, index) in companyData.person" :key="index">
                  <el-col :span="12">
                    <el-form-item label="对接人姓名：" :prop="`person.${index}.name`" :rules="rules.name">
                      <el-input :style="'width:100%'" v-model="item.name" placeholder="请输入对接人姓名" autocomplete="off" size="mini" />
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="对接人电话：" :prop="`person.${index}.tell`" :rules="rules.tell">
                      <el-input :style="'width:100%'" v-model="item.tell" placeholder="请输入对接人电话" autocomplete="off" size="mini" />
                    </el-form-item>
                  </el-col>
                  <el-col>
                    <el-form-item label="对接人职位：" :prop="`person.${index}.position`" :rules="rules.position">
                      <div style="display: flex; align-items: center">
                        <el-input :style="'width:50%'" v-model="item.position" placeholder="请输入对接人职位" autocomplete="off" size="mini" />
                        <div style="display: flex; align-items: center; margin-left: 25px" v-if="index === companyData.person.length - 1">
                          <el-button style="margin-left: 10px; height: 22px; width: 22px; display: flex; align-items: center; justify-content: center; padding: 0" size="mini" type="info" icon="el-icon-plus" circle @click="levelAdd" />
                          <el-button v-if="companyData.person.length !== 1" style="height: 22px; width: 22px; display: flex; align-items: center; justify-content: center; padding: 0" size="mini" type="info" icon="el-icon-minus" circle @click="levelMinus" />
                        </div>
                      </div>
                    </el-form-item>
                  </el-col>
                </div>
                <el-col>
                  <el-form-item :label="dialogTitle == '修改委托商' ? '修改原因：' : '新增原因：'" prop="remark" style="margin-top: 5px; margin-bottom: 20px">
                    <el-input type="textarea" :style="'width:100%;'" :rows="4" v-model="companyData.remark" placeholder="请输入新增原因" autocomplete="off" size="mini" />
                  </el-form-item>
                </el-col>
              </el-row>
            </div-border>
            <div-border label="上传附件" :isNeed="true">
              <el-form-item style="margin-top: 15px" label-width="50px">
                <div class="imgUp">
                  <el-upload ref="upload" class="upload-demo" :action="uploadUrl" :before-upload="beforeAvatarUpload" :show-file-list="false" :data="uploadData" :on-change="uploadChange" :on-progress="progress" :on-success="success" :file-list="companyData.enclosure" :limit="5">
                    <!--                    <i class="el-icon-plus"/>-->
                    <el-button size="small" type="primary" :loading="imgIsUpload">点击上传</el-button>
                    <div slot="tip" style="margin-top: 6px; margin-left: 10px">支持扩展名：.rar .zip .doc .docx .pdf .jpg...</div>
                  </el-upload>
                  <div v-for="(item, index) in companyData.enclosure">
                    <div class="upload">
                      {{ item.name }}
                      <div>
                        <i class="el-icon-zoom-in" @click="handlePictureCardPreview(item, index)" v-if="item.name.substring(item.name.indexOf('.')) === '.jpeg' || item.name.substring(item.name.indexOf('.')) === '.png' || item.name.substring(item.name.indexOf('.')) === '.jpg' || item.name.substring(item.name.indexOf('.')) === '.JPG' || item.name.substring(item.name.indexOf('.')) === '.gif'"></i>
                        <i class="el-icon-upload2" @click="uploadClick(item, index)"></i>
                        <i class="el-icon-delete" @click="handleRemove(item, index)"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </el-form-item>
            </div-border>
            <div class="btnContainer">
              <el-button class="searchBtn" size="medium" :loading="btnLoading" @click="addClick"> 确定 </el-button>
              <el-button class="resetBtn" size="medium" @click="dialogClose">关闭</el-button>
            </div>
          </el-form>
        </el-row>
      </popup>
    </transition>
    <el-dialog title="详情" :visible.sync="detailDialogVisible" width="650px" center top="10vh">
      <div class="detail">
        <div class="baseInfo">
          <div class="baseInfoTitle">
            <div class="line" />
            <span>基础信息</span>
            <p :style="getStyle(detailData.status)">{{ getState(detailData.status) }}</p>
          </div>
          <div class="baseInfoContent">
            <div class="baseInfoContentItem">
              <span class="span1">委托公司名称：</span>
              <el-badge value="危" class="item" :hidden="!detailData.isRisky">
                <div style="height: 18px">
                  <span>{{ detailData.customerName }}</span>
                </div>
              </el-badge>
            </div>
            <div class="baseInfoContentItem">
              <span class="span1">委托公司简称：</span>
              <span>{{ detailData.customerSimple }}</span>
            </div>
            <div class="baseInfoContentItem">
              <span class="span1">关键词：</span>
              <span>{{ detailData.keyWord }}</span>
            </div>
            <div class="baseInfoContentItem">
              <span class="span1">客户类型：</span>
              <span v-for="(item, index) in detailData.customer">{{ item }}<span v-if="index !== detailData.customer.length - 1">、</span></span>
            </div>
            <div class="baseInfoContentItem specialItem">
              <div class="specialOne">
                <span class="span1">公司性质：</span>
                <span>{{ detailData.customerNatureName }}</span>
              </div>
              <div>
                <span class="span1">公司规模：</span>
                <span>{{ detailData.customerScaleName }}</span>
              </div>
            </div>
            <div class="baseInfoContentItem specialItem">
              <div class="specialOne">
                <span class="span1">经营范围：</span>
                <span>{{ detailData.businessScope }}</span>
              </div>
              <div>
                <span class="span1">注册资金：</span>
                <span>{{ detailData.registeredCapital }}</span>
              </div>
            </div>
            <div class="baseInfoContentItem specialItem">
              <div class="specialOne">
                <span class="span1">公司联系电话：</span>
                <span>{{ detailData.telephone }}</span>
              </div>
              <div>
                <span class="span1">公司邮箱：</span>
                <span>{{ detailData.mailbox }}</span>
              </div>
            </div>
            <!--            <div class="baseInfoContentItem">-->
            <!--              <span class="span1">详细地址：</span>-->
            <!--              <span>{{detailData.address}}</span>-->
            <!--            </div>-->
            <div class="baseInfoContentItem specialItem">
              <div class="specialOne">
                <span class="span1">公司开户行：</span>
                <span>{{ detailData.openAccountBank }}</span>
              </div>
              <div>
                <span class="span1">银行卡号码：</span>
                <span>{{ detailData.bankCardNumber }}</span>
              </div>
            </div>
            <div class="baseInfoContentItem specialItem">
              <div class="specialOne">
                <span class="span1">纳税号：</span>
                <span>{{ detailData.sellerTaxno }}</span>
              </div>
            </div>
            <div class="baseInfoContentItem specialItem">
              <div class="specialOne">
                <span class="span1">业务来源：</span>
                <span>{{ detailData.businessSource }}</span>
              </div>
              <div>
                <span class="span1">客户行业：</span>
                <span>{{ detailData.customerIndustry }}</span>
              </div>
            </div>
            <div v-for="item in detailData.person" :key="item">
              <div class="baseInfoContentItem specialItem">
                <div class="specialOne">
                  <span class="span1">对接人姓名：</span>
                  <span>{{ item.name }}</span>
                </div>
                <div>
                  <span class="span1">对接人手机：</span>
                  <span>{{ item.tell }}</span>
                </div>
              </div>
              <div class="baseInfoContentItem">
                <span class="span1">对接人职位：</span>
                <span>{{ item.position }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="baseInfo">
          <div class="baseInfoTitle">
            <div class="line" />
            <span>附件信息</span>
          </div>
          <div class="attachment">
            <div v-for="item in detailData.attachData" class="attachmentItem">
              <span style="text-decoration: underline; cursor: pointer">{{ item.name }}</span>
              <span>{{ item.time }}</span>
              <i class="el-icon-zoom-in" @click="handlePictureCardPreview(item)" v-if="item.name.substring(item.name.indexOf('.')) == '.jpeg' || item.name.substring(item.name.indexOf('.')) == '.jpg' || item.name.substring(item.name.indexOf('.')) == '.JPG' || item.name.substring(item.name.indexOf('.')) == '.png' || item.name.substring(item.name.indexOf('.')) == '.gif'"> </i>
              <i class="el-icon-download" @click="downloadClick(item.id)"></i>
            </div>
          </div>
        </div>
        <!--        <div class="baseInfo">-->
        <!--          <div class="baseInfoTitle">-->
        <!--            <div class="line"/>-->
        <!--            <span>审核信息</span>-->
        <!--          </div>-->
        <!--          <steps :step-data="stepData" :step-state="stepState"/>-->
        <!--        </div>-->
        <div class="operation">
          <div class="operationTitle">
            <div class="line" />
            <span>操作信息</span>
          </div>
          <div class="operationTable">
            <el-table :data="operationData" border>
              <el-table-column label="操作时间" align="center" width="160px">
                <div slot-scope="scope">{{ getTime(scope.row.createTime) }}</div>
              </el-table-column>
              <el-table-column prop="operateType" label="操作类型" align="center" />
              <el-table-column prop="operationName" label="操作人" align="center" />
              <el-table-column prop="remark" label="备注" align="center" />
            </el-table>
          </div>
        </div>
      </div>
    </el-dialog>
    <transition name="el-fade-in-linear">
      <popup title="修改委托商基础信息" :show.sync="basicInfoVisible" width="700" center :close-on-click-modal="false">
        <div class="detail">
          <div-border label="基础信息" divStyle="margin-top: 10px">
            <div class="baseInfo">
              <div class="baseInfoContent">
                <div class="baseInfoContentItem">
                  <span class="span1">委托商全称：</span>
                  <!--                <span>{{basicInfoData.company}}</span>-->
                  <el-badge value="危" class="item" :hidden="!basicInfoData.isRisky">
                    <div style="height: 20px">
                      {{ basicInfoData.customerName }}
                    </div>
                  </el-badge>
                </div>
                <div class="baseInfoContentItem">
                  <span class="span1">委托商简称：</span>
                  <span>{{ basicInfoData.customerSimple }}</span>
                </div>
                <div class="baseInfoContentItem specialItem">
                  <div class="specialOne">
                    <span class="span1">客户类型：</span>
                    <span v-for="(item, index) in basicInfoData.customer">{{ item }}<span v-if="index !== basicInfoData.customer.length - 1">、</span></span>
                  </div>
                  <div>
                    <span class="span1">是否危险用户：</span>
                    <span>{{ basicInfoData.isRisky ? '是' : '否' }}</span>
                  </div>
                </div>
                <div class="baseInfoContentItem specialItem">
                  <div class="specialOne">
                    <span class="span1">开户行：</span>
                    <span>{{ basicInfoData.openAccountBank }}</span>
                  </div>
                  <div>
                    <span class="span1">银行卡号：</span>
                    <span>{{ basicInfoData.bankCardNumber }}</span>
                  </div>
                </div>
                <div class="baseInfoContentItem specialItem">
                  <div class="specialOne">
                    <span class="span1">业务来源：</span>
                    <span>{{ detailData.businessSource }}</span>
                  </div>
                  <div>
                    <span class="span1">客户行业：</span>
                    <span>{{ detailData.customerIndustry }}</span>
                  </div>
                </div>
                <div v-for="item in basicInfoData.person">
                  <div class="baseInfoContentItem specialItem">
                    <div class="specialOne">
                      <span class="span1">对接人姓名：</span>
                      <span>{{ item.name }}</span>
                    </div>
                    <div>
                      <span class="span1">对接人手机：</span>
                      <span>{{ item.tell }}</span>
                    </div>
                  </div>
                  <div class="baseInfoContentItem">
                    <span class="span1">对接人职位：</span>
                    <!--                  <span v-for="(innerItem,index) in item.position">{{innerItem}}<span>、</span></span>-->
                    <span>{{ item.position }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div-border>
          <div class="depart" style="height: auto">
            <el-form :model="basicInfoData" label-width="120px" :rules="rules2" ref="ruleForm2" size="medium">
              <div-border label="修改资料" divStyle="margin-top: 10px">
                <el-row>
                  <el-col>
                    <el-form-item label="关键词：" prop="keyWord" style="margin-top: 10px">
                      <el-input :style="'width:100%'" v-model="basicInfoData.keyWord" placeholder="请输入委托商关键词" autocomplete="off" size="mini" />
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="公司性质：" prop="enterprise">
                      <el-select v-model="basicInfoData.enterprise" filterable size="mini" style="width: 100%" placeholder="请输入公司性质" value-key="id">
                        <el-option v-for="item in enterpriseOption2" :key="item.id" :label="item.attrNm" :value="item" />
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="公司规模：">
                      <el-select v-model="basicInfoData.size" size="mini" filterable style="width: 100%" placeholder="请输入公司性质" value-key="id">
                        <el-option v-for="item in sizeOption" :key="item.id" :label="item.attrNm" :value="item" />
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="经营范围：">
                      <el-input :style="'width:100%'" v-model="basicInfoData.businessScope" placeholder="请输入经营范围" autocomplete="off" size="mini" />
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="注册资金：">
                      <el-input :style="'width:100%'" v-model="basicInfoData.registeredCapital" placeholder="请输入注册资金" autocomplete="off" size="mini" />
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="联系电话：" prop="telephone">
                      <el-input :style="'width:100%'" v-model="basicInfoData.telephone" placeholder="请输入委托商联系电话" autocomplete="off" size="mini" />
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="联系邮箱：">
                      <el-input :style="'width:100%'" v-model="basicInfoData.mailbox" placeholder="请输入委托商联系邮箱" autocomplete="off" size="mini" />
                    </el-form-item>
                  </el-col>
                  <el-col>
                    <!--                    <el-form-item label="详细地址：" prop="address">-->
                    <!--                      <div style="display: flex;cursor: pointer;align-items: center;" @click="mapVisible2=true">-->
                    <!--                        <el-input-->
                    <!--                          :disabled="true"-->
                    <!--                          style="width:90%;margin-right: 10px;"-->
                    <!--                          :style="'width:100%'"-->
                    <!--                          v-model="basicInfoData.address"-->
                    <!--                          placeholder="请输入详细地址"-->
                    <!--                          autocomplete="off"-->
                    <!--                          size="mini"-->
                    <!--                        />-->
                    <!--                        <i class="el-icon-location"/>-->
                    <!--                      </div>-->
                    <!--                    </el-form-item>-->
                  </el-col>
                </el-row>
              </div-border>
              <div class="btnContainer">
                <el-button class="searchBtn" size="medium" :loading="btnLoading" @click="basicInfoConfirmClick">确认 </el-button>
                <el-button class="resetBtn" size="medium" @click="basicInfoClose">取消</el-button>
              </div>
            </el-form>
          </div>
        </div>
      </popup>
    </transition>
    <el-dialog title="终止合作" :visible.sync="cooperation" width="500px" center :close-on-click-modal="false">
      <div class="cooperation">
        <p><span style="color: red">*</span>终止合作原因：</p>
        <el-input type="textarea" style="width: 400px; margin-left: 30px; margin-bottom: 20px" v-model="remark" placeholder="请输入终止合作原因" autocomplete="off" size="mini" />
        <div class="btnContainer">
          <el-button size="medium" class="searchBtn" @click="cooperationClick">确认</el-button>
          <el-button size="medium" class="resetBtn" @click="cooperation = false">取消</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="imgDialogVisible" width="200px;" append-to-body>
      <img style="width: 100%; object-fit: cover" :src="dialogImageUrl" alt="" />
    </el-dialog>
    <transition name="el-fade-in-linear">
      <popup width="850" title="详细地址" :show.sync="mapVisible" center>
        <web-map :useType="'select'" @close="mapClose" v-if="mapVisible" :address="companyData.address" />
      </popup>
    </transition>
    <transition name="el-fade-in-linear">
      <popup width="850" title="详细地址" :show.sync="mapVisible2" center>
        <web-map :useType="'select'" @close="mapClose2" v-if="mapVisible2" :address="basicInfoData.address" />
      </popup>
    </transition>
  </div>
</template>

<script>
  import steps from '@/components/steps';
  import divBorder from '@/components/divBorder';
  import { formatDateTime, getSessionStore, removeSpace } from '@/config/mUtils';
  import { customerInfoPageList, customerTypeSelectList, customerNature, customerDetail, companyScale, endCooperation, customerAdd, customerEdit, customerTypeInfoChange, customerTypeBasicInfoUpdate, dropDownData, getSupplierMasterDate } from '@/service/basicfile';
  import { baseUrl, baseImgUrl } from '@/config/env';
  import webMap from '@/components/map';
  import popup from '@/components/popup';
  import { selectListBySourceId } from '@/service/getData';
  import $ from 'jquery';
  import batchImport from '@/components/batchImport';
  import { getImport, getImportUrl } from '@/service/getIP';

  export default {
    components: {
      steps,
      divBorder,
      webMap,
      popup,
      batchImport,
    },
    data() {
      const validateTell = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入联系电话'));
        } else if (!/^[1][3,4,5,7,8,9][0-9]{9}$/.test(value)) {
          callback(new Error('请输入正确的手机号'));
        } else {
          callback();
        }
      };
      const validateBank = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入公司银行卡号'));
        } else if (value.length < 6) {
          callback(new Error('请输入正确银行卡号！'));
        } else {
          callback();
        }
        // else if (!( /^([1-9]{1})(\d{11}|\d{15}|\d{16}|\d{17}|\d{18})$/).test(value)) {
        //   callback(new Error('请输入正确的公司银行卡号'));
        // }
      };
      return {
        pageLoading: false,
        btnLoading: false,
        mapVisible: false,
        mapVisible2: false,
        companyIpt: '',
        customerIpt: '',
        enterpriseIpt: '',
        stateIpt: '',
        customerOption2: [],
        customerOption: [],
        enterpriseOption: [
          {
            id: '',
            classaName: '全部',
          },
        ],
        stateOption: [
          {
            value: '',
            label: '全部',
          },
          {
            value: 0,
            label: '待审核',
          },
          {
            value: 1,
            label: '合作中',
          },
          {
            value: 2,
            label: '已退出',
          },
          {
            value: 3,
            label: '待完善',
          },
        ],
        tableLoad: false,
        TableDatas: [],
        page: 1,
        size: 10,
        total: 0,
        dialogTitle: '',
        dialogVisible: false,
        dialogImageUrl: '',
        companyData: {
          company: '',
          referred: '',
          keyword: '',
          customer: [],
          danger: 0,
          enterprise: '',
          scope: '',
          registered: '',
          size: '',
          cTell: '',
          mail: '',
          address: '',
          sellerTaxno: '',
          bank: '',
          bankNo: '',
          person: [
            {
              name: '',
              tell: '',
              position: '',
            },
          ],
          remark: '',
          contract: '',
          enclosure: [], //附件
        },
        formLoading: false, //提交等待加载
        uploadData: {
          fileType: 0,
        },
        imgDialogVisible: false,
        imgIsUpload: false,
        uploadUrl: '',
        importUrl: '', //导入地址
        uploadData1: {
          mFile: '',
        },
        uploadFlag: false, //替换
        uploadIndex: '', //替换索引
        rules: {
          businessSourceId: [
            {
              required: true,
              message: '请选择业务来源',
              trigger: 'blur',
            },
          ],
          customerIndustryId: [
            {
              required: true,
              message: '请选择客户行业',
              trigger: 'blur',
            },
          ],
          company: [
            {
              required: true,
              message: '请输入委托商全称',
              trigger: 'blur',
            },
          ],
          nature: [
            {
              required: true,
              message: '请选择公司性质',
              trigger: 'change',
            },
          ],
          referred: [
            {
              required: true,
              message: '请输入委托商简称',
              trigger: 'blur',
            },
          ],
          cTell: [
            {
              required: true,
              validator: validateTell,
              trigger: 'blur',
            },
          ],
          mail: [
            {
              required: true,
              message: '请输入委托商联系邮箱',
              trigger: 'blur',
            },
          ],
          address: [
            {
              required: true,
              message: '请输入委托商详细地址',
              trigger: 'blur',
            },
          ],
          keyword: [
            {
              required: true,
              message: '请输入委托商关键词',
              trigger: 'blur',
            },
          ],
          customer: [
            {
              required: true,
              message: '请选择客户类型',
              trigger: 'change',
            },
          ],
          danger: [
            {
              required: true,
              message: '请选择是否危险用户',
              trigger: 'change',
            },
          ],
          sellerTaxno: [
            {
              required: true,
              message: '请输入纳税号',
              trigger: 'blur',
            },
          ],
          bank: [
            {
              required: true,
              message: '请输入公司开户行',
              trigger: 'blur',
            },
          ],
          bankNo: [
            {
              required: true,
              validator: validateBank,
              trigger: 'blur',
            },
          ],
          name: [
            {
              required: true,
              message: '请输入对接人姓名',
              trigger: 'blur',
            },
          ],
          tell: [
            {
              required: true,
              validator: validateTell,
              trigger: 'blur',
            },
          ],
          position: [
            {
              required: true,
              message: '请输入对接人职位',
              trigger: 'blur',
            },
          ],
          remark: [
            {
              required: true,
              message: '请输入新增原因',
              trigger: 'blur',
            },
          ],
          contract: [
            {
              required: true,
              message: '请输入合同编号',
              trigger: 'blur',
            },
          ],
          date: [
            {
              required: true,
              message: '请输入合同起止日期',
              trigger: 'blur',
            },
          ],
        },
        detailDialogVisible: false,
        detailData: {},
        enterpriseOption2: [],
        sizeOption: [],
        selectedData: {},
        operationWidth: '', //表格宽度
        cooperation: false,
        remark: '',
        basicInfoVisible: false,
        basicInfoData: {},
        rules2: {
          keyWord: [
            {
              required: true,
              message: '请输入委托商关键词',
              trigger: 'blur',
            },
          ],
          enterprise: [
            {
              required: true,
              message: '请输入公司性质',
              trigger: 'blur',
            },
          ],
          telephone: [
            {
              required: true,
              message: '请输入委托商联系电话',
              trigger: 'blur',
            },
          ],
          address: [
            {
              required: true,
              message: '请输入公司详细地址',
              trigger: 'blur',
            },
          ],
        },
        operationData: [],
        stepData: [
          {
            title: '张三发起',
            time: '2021-9-30 14:09:23',
            state: '',
            remark: '',
          },
          {
            title: '财务部 张三通过',
            time: '2021-9-30 14:09:23',
            state: 'success',
            remark: '原因xxxxxx',
          },
          {
            title: '技术部 李四拒绝',
            time: '2021-9-30 14:09:23',
            state: 'failure',
            remark: '原因xxxxxx',
          },
          {
            title: '张三重新发起',
            time: '2021-9-30 14:09:23',
            state: '',
            remark: '',
          },
        ],
        refusedId: '',
        baseImgUrl: baseImgUrl + '/',
      };
    },
    computed: {
      stepState() {
        return function (state) {
          switch (state) {
            case '':
              return 'wait';
            case 'success':
              return 'success';
            case 'failure':
              return 'error';
          }
        };
      },
      getStyle() {
        return val => {
          switch (val) {
            case 1:
              return 'color: rgba(51, 84, 131, 100);';
            case 0:
              return 'color: rgba(249, 166, 6, 1)';
            case 2:
              return 'color:#F56C6C;';
          }
        };
      },
      getState() {
        return function (state) {
          switch (state) {
            case 0:
              return '待审核';
            case 1:
              return '合作中';
            case 2:
              return '已退出';
            case 3:
              return '待完善';
          }
        };
      },
      getTime() {
        return function (time) {
          return formatDateTime(time, 'yyyy年mm月dd日 hh:ii:ss');
        };
      },
      tableIndexMethod(index) {
        return function (index) {
          return this.size * (this.page - 1) + index + 1;
        };
      },
    },
    created() {
      let token = getSessionStore('token');
      // this.importUrl = baseUrl + `/platform/sys/customerInfo/batchAddCustomerInfo?access_token=${token}`;
      this.importUrl = getImportUrl('/sys/customerInfo/batchAddCustomerInfo');
      console.log(this.importUrl);
      this.uploadUrl = getImportUrl('/transport-plan-cv/importExcelxls');
    },
    mounted() {
      this.init();
      this.dropDownData();
      this.uploadUrl = baseUrl + '/web/attachmentFtp/upload';
    },
    methods: {
      async init() {
        await this._customerInfoPageList();

        const res2 = await customerTypeSelectList();
        if (res2.status !== 0) {
          this.$message.error(res2.message);
        } else {
          this.customerOption2 = [
            {
              id: '',
              type_name: '全部',
            },
            ...res2.data,
          ];
          this.customerOption = res2.data;
        }
        // const res3 = await customerNature();
        const res3 = await customerNature({ categoryCd: 'consignor_nature' });
        if (res3.status !== 0) {
          this.$message.error(res3.message);
        } else {
          res3.data.forEach(item => this.enterpriseOption.push(item));
          this.enterpriseOption2 = res3.data.map(item => {
            return {
              id: item.id,
              attrNm: item.classaName,
            };
          });
        }
      },
      async _customerInfoPageList() {
        const obj = {
          customerName: this.companyIpt,
          typeId: this.customerIpt,
          customerNatureId: this.enterpriseIpt,
          status: this.stateIpt,
          rows: this.size,
          page: this.page,
        };
        this.tableLoad = true;
        const res = await customerInfoPageList(obj);
        this.tableLoad = false;
        if (res.status !== 0) return this.$message.error(res.message);
        res.data.records.forEach(item => {
          if (item.typeName) item.type = item.typeName.split(',');
        });
        this.TableDatas = res.data.records;
        this.total = res.data.total;
        // debugger
        this.sunWidth();
      },
      async cooperationClick() {
        this.remark = this.remark.trim();
        if (this.remark !== '') {
          const res = await endCooperation({
            id: this.refusedId,
            endCooperatioReason: this.remark,
          });
          if (res.status !== 0) return this.$message.error(res.message);
          this.$message.success(res.message);
          await this._customerInfoPageList();
          this.cooperation = false;
        } else {
          this.$message.warning('终止原因不能为空！');
        }
      },
      mapClose(val, lnglat) {
        console.log(val, 'val');
        console.log(lnglat, 'lnglat');
        this.companyData.address = val;
        this.companyData.longitude = lnglat[0];
        this.companyData.latitude = lnglat[1];
        this.mapVisible = false;
      },
      mapClose2(val, lnglat) {
        console.log(val, 'val');
        console.log(lnglat, 'lnglat');
        this.basicInfoData.address = val;
        this.basicInfoData.longitude = lnglat[0];
        this.basicInfoData.latitude = lnglat[1];
        this.mapVisible2 = false;
      },
      levelMinus() {
        this.companyData.person.pop();
      },
      levelAdd() {
        this.companyData.person.push({
          name: '',
          tell: '',
          position: '',
        });
      },
      tableRowClassName({ row }) {
        if (row.status === 2) {
          return 'ui-warning-row';
        } else {
          return '';
        }
      },
      resetBtn() {
        this.companyIpt = '';
        this.customerIpt = '';
        this.enterpriseIpt = '';
        this.stateIpt = '';
      },
      searchBtn() {
        this.page = 1;
        this._customerInfoPageList();
      },
      /**
       * 导入成功
       * @param data 分页更新数据
       */
      // importSuccess(data){
      //   console.log(data)
      //   this._customerInfoPageList();
      // },
      // 批量导入
      planOnSuccess(res) {
        this.pageLoading = false;
        // if (res.status !== 0) return this.$message.error(res.message);
        // this.$message.success(res.message);
        // this.TableDatas = res.data;
        // this._customerInfoPageList();
        this.$alert(res.message, '提示', {
          confirmButtonText: '关闭',
          callback: async () => {
            this.TableDatas = res.data;
            await this._customerInfoPageList();
          },
        });
      },
      beforeUpload(file) {
        // console.log(file);
        if (file.name.split('.')[1] == 'xls' || file.name.split('.')[1] == 'xlsx') {
          this.uploadData1.mFile = file.name;
          this.pageLoading = true;
        } else {
          this.$message.error('请选择excel文件导入！！！');
          return false;
        }
      },
      //模板下载
      download() {
        // window.location.href = "/file/entrustImport.xlsx";
        this.$axios
          .get('/file/委托商导入模板.xlsx', {
            responseType: 'blob', //重要
          })
          .then(response => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            let fname = '委托商导入模板.xlsx';
            link.href = url;
            link.setAttribute('download', fname);
            document.body.appendChild(link);
            link.click();
          });
      },
      /**
       * 同步
       */
      async synchronize() {
        this.$prompt('委托商名称', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        }).then(async ({ value }) => {
          this.pageLoading = true;
          const { status, message } = await getSupplierMasterDate({ type: 1, nameChs: value });
          if (status !== 0) return this.$message.warning(message);
          this.$message.success(message);
          this.pageLoading = false;
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消输入'
          });
        });
        // this.pageLoading = true;
        // const { status, message } = await getSupplierMasterDate({ type: 1 });
        // this.pageLoading = false;
        // if (status !== 0) return this.$message.warning(message);
        // this.$message.success(message);
      },
      async addBtn() {
        this.dialogVisible = true;
        this.dialogTitle = '新增委托商';
        this.companyData = {
          company: '',
          keyword: '',
          customer: [],
          danger: 0,
          enterprise: '',
          scope: '',
          registered: '',
          size: '',
          cTell: '',
          mail: '',
          address: '',
          sellerTaxno: '',
          bank: '',
          bankNo: '',
          person: [
            {
              name: '',
              tell: '',
              position: '',
            },
          ],
          remark: '',
          remark2: '123',
          enclosure: [], //附件
        };
        // const res =await companyScale();
        const res = await companyScale({ categoryCd: 'consignor_scale' });
        if (res.status !== 0) {
          this.$message.error(res.message);
        } else {
          this.sizeOption = res.data.map(item => {
            return {
              id: item.id,
              attrNm: item.classaName,
            };
          });
        }
      },
      async dropDownData() {
        const { status, message, data } = await dropDownData();
        if (status !== 0) return this.$message.warning(message);
        this.selectedData = data;
      },
      async editBtn(id) {
        this.dialogVisible = true;
        this.dialogTitle = '修改委托商';
        const res1 = await customerDetail(id);

        if (res1.status !== 0) return this.$message.error(res.message);
        let item = res1.data;
        let nameStr, tellStr, positionStr, arr;
        if (item.directorName) nameStr = item.directorName.split(',');
        if (item.directorMobile) tellStr = item.directorMobile.split(',');
        if (item.directorPost) positionStr = item.directorPost.split(',');
        if (nameStr)
          arr = nameStr.map((item, index) => {
            return {
              name: item,
              tell: tellStr[index],
              position: positionStr[index],
            };
          });
        else arr = [{ name: '', tell: '', position: '' }];
        this.companyData = {
          ...item,
          company: item.customerName,
          referred: item.customerSimple,
          keyword: item.keyWord,
          customer: item.typeId ? item.typeId.split(',') : '',
          danger: item.isRisky,
          sellerTaxno: item.sellerTaxno,
          bank: item.openAccountBank,
          bankNo: item.bankCardNumber,
          person: arr,
          enclosure: [],
          nature: {
            id: item.customerNatureId,
            classaName: item.customerNatureName,
          },
          size: {
            id: item.customerScaleId,
            classaName: item.customerScaleName,
          },
          scope: item.businessScope,
          registered: item.registeredCapital,
          cTell: item.telephone,
          mail: item.mailbox,
          remark: item.explains,
        };
        const res2 = await selectListBySourceId(item.id);
        if (res2.status !== 0) return this.$message.error(res.message);
        this.companyData.enclosure = res2.data.map(item => {
          return {
            name: item.attachmentName,
            time: item.uploadTime,
            url: this.baseImgUrl + item.attachmentGroup + '/' + item.attachmentPath,
            id: item.id,
          };
        });
        // const res =await companyScale();
        const res = await companyScale({ categoryCd: 'consignor_scale' });
        if (res.status !== 0) {
          this.$message.error(res.message);
        } else {
          this.sizeOption = res.data.map(item => {
            return {
              id: item.id,
              attrNm: item.classaName,
            };
          });
        }
      },
      sunWidth() {
        // debugger
        this.operationWidth = 0;
        this.$nextTick(() => {
          let divDom = $('.dynamicWidth');
          console.log(divDom);
          // 保存按钮最大数
          let max = $(divDom[0]).children().length;
          console.log(max, 'max');
          //保存最大数所在div索引
          let divIndex = 0;
          divDom.each((index, item) => {
            if ($(item).children().length >= max) {
              // 如果大于就重新赋值
              max = $(item).children().length;
              divIndex = index;
            }
          });
          //得到最大button个数 所在div 获取button元素
          $(divDom[divIndex])
            .children()
            .each((index, item) => {
              console.log($(item).innerWidth());
              this.operationWidth += $(item).innerWidth() + 15;
            });
        });
      },
      contractSizeChange(sizes) {
        this.size = sizes;
        this._customerInfoPageList();
      },
      contractCurrentChange(page) {
        this.page = page;
        this._customerInfoPageList();
      },
      async detailClick(id) {
        this.detailData = {};
        this.detailDialogVisible = true;
        const res = await customerDetail(id);
        if (res.status !== 0) return this.$message.error(res.message);
        this.operationData = res.data.operateRecordList;
        let arr1, arr2, arr3;
        if (res.data.directorName) arr1 = res.data.directorName.split(',');
        if (res.data.directorMobile) arr2 = res.data.directorMobile.split(',');
        if (res.data.directorPost) arr3 = res.data.directorPost.split(',');
        const arr = [];
        if (arr1)
          arr1.forEach((item, index) =>
            arr.push({
              name: item,
              tell: arr2[index],
              position: arr3[index],
            }),
          );
        this.detailData = {
          ...res.data,
          customer: res.data.typeName ? res.data.typeName.split(',') : '',
          person: arr,
          attachData: [],
        };
        // const res2 = await selectListBySourceId(id);
        // if(res2.status !== 0) return this.$message.error(res2.message);
        this.detailData.attachData = res.data.attachmentList.map(item => {
          return {
            name: item.attachmentName,
            time: item.uploadTime,
            id: item.id,
            url: item.attachmentGroup + '/' + item.attachmentPath,
          };
        });
      },
      disableClick() {
        this.$confirm('确定要取消审核修改吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {})
          .catch(() => {});
      },
      enableClick(id) {
        this.remark = '';
        this.refusedId = id;
        this.cooperation = true;
      },
      async basicInfoClick(row) {
        this.basicInfoVisible = true;
        const arr = [];
        const res2 = await customerDetail(row.id);
        if (res2.status !== 0) return this.$message.error(res2.message);
        let item = res2.data;
        const nameStr = item.directorName.split(',');
        const tellStr = item.directorMobile.split(',');
        const positionStr = item.directorPost.split(',');
        nameStr.forEach((item, index) =>
          arr.push({
            name: item,
            tell: tellStr[index],
            position: positionStr[index],
          }),
        );
        this.basicInfoData = {
          ...item,
          customer: item.typeName.split(','),
          person: arr,
          enterprise: {
            id: item.customerNatureId,
            attrNm: item.customerNatureName,
          },
          size: {
            id: item.customerScaleId,
            attrNm: item.customerScaleName,
          },
        };
        var param = {};
        param.categoryCd = 'consignor_scale';
        const res = await companyScale(param);
        if (res.status !== 0) {
          this.$message.error(res.message);
        } else {
          this.sizeOption = res.data.map(item => {
            return {
              id: item.id,
              attrNm: item.classaName,
            };
          });
        }
      },
      basicInfoConfirmClick() {
        this.$refs.ruleForm2.validate(async valid => {
          if (valid) {
            const obj = {
              id: this.basicInfoData.id,
              keyWord: this.basicInfoData.keyWord,
              customerNatureId: this.basicInfoData.enterprise.id,
              customerNatureName: this.basicInfoData.enterprise.attrNm,
              customerScaleId: this.basicInfoData.size.id,
              customerScaleName: this.basicInfoData.size.attrNm,
              businessScope: this.basicInfoData.businessScope,
              registeredCapital: this.basicInfoData.registeredCapital,
              telephone: this.basicInfoData.telephone,
              mailbox: this.basicInfoData.mailbox,
              // address:this.basicInfoData.address,
              // longitude:this.basicInfoData.longitude,
              // latitude:this.basicInfoData.latitude,
            };
            this.btnLoading = true;
            const res = await customerTypeBasicInfoUpdate(obj);
            this.btnLoading = false;
            if (res.status !== 0) return this.$message.error(res.message);
            this.$message.success(res.message);
            this.basicInfoVisible = false;
            await this._customerInfoPageList();
          } else {
            return false;
          }
        });
      },
      exportClick() {
        const obj = {
          customerName: this.companyIpt,
          typeId: this.customerIpt,
          customerNatureId: this.enterpriseIpt,
          status: this.stateIpt,
          rows: this.size,
          page: this.page,
        };
        // let token = getSessionStore('token');
        // window.location.href = `${baseUrl}/platform/sys/customerInfo/exportXls?access_token=${token}&customerName=${obj.customerName}&typeId=${obj.typeId}&customerNatureId=${obj.customerNatureId}&status=${obj.status}`;
        window.exportExcelGet('/platform/sys/customerInfo/exportXls', `customerName=${obj.customerName}&typeId=${obj.typeId}&customerNatureId=${obj.customerNatureId}&status=${obj.status}`)
      },
      basicInfoClose() {
        this.$refs.ruleForm2.resetFields();
        this.basicInfoVisible = false;
      },
      async changeClick(row) {
        this.dialogVisible = true;
        this.dialogTitle = '信息变更';
        const res2 = await customerDetail(row.id);
        if (res2.status !== 0) return this.$message.error(res2.message);
        let item = res2.data;
        const nameStr = item.directorName.split(',');
        const tellStr = item.directorMobile.split(',');
        const positionStr = item.directorPost.split(',');
        const arr = nameStr.map((item, index) => {
          return {
            name: item,
            tell: tellStr[index],
            position: positionStr[index],
          };
        });
        this.companyData = {
          ...item,
          company: item.customerName,
          referred: item.customerSimple,
          keyword: item.keyWord,
          customer: item.typeId.split(','),
          danger: item.isRisky,
          sellerTaxno: item.sellerTaxno,
          bank: item.openAccountBank,
          bankNo: item.bankCardNumber,
          person: arr,
          remark: item.explains,
          enclosure: [],
        };
        const res = await selectListBySourceId(item.id);
        if (res.status !== 0) return this.$message.error(res.message);
        this.companyData.enclosure = res.data.map(item => {
          return {
            name: item.attachmentName,
            time: item.uploadTime,
            url: this.baseImgUrl + item.attachmentGroup + '/' + item.attachmentPath,
            id: item.id,
          };
        });
      },
      dialogClose() {
        this.dialogVisible = false;
        this.$refs.ruleForm.resetFields();
      },
      imgClick(val, name, id) {
        const arr = ['.jpeg', '.png', '.jpg', '.JPG', '.gif', '.PNG'];
        let str = name.substring(name.indexOf('.'));
        if (arr.indexOf(str) === -1) {
          let token = getSessionStore('token');
          window.location.href = baseUrl + '/web/attachmentFtp/download?access_token=' + token + '&attachmentId=' + id;
          return;
        }
        this.dialogImageUrl = this.baseImgUrl + val;
        this.imgDialogVisible = true;
      },
      downloadClick(id) {
        if (id) {
          let token = getSessionStore('token');
          window.location.href = baseUrl + '/web/attachmentFtp/download?attachmentId=' + id + '&access_token=' + token;
        } else {
          this.$message.warning('下载失败');
        }
      },
      addClick() {
        this.companyData = removeSpace(this.companyData);
        this.$refs.ruleForm.validate(async valid => {
          if (valid) {
            // if ( this.companyData.enclosure.length===0) return this.$message.warning('至少上传一个附件！！')
            if (this.imgIsUpload) return this.$message.warning('还有附件正在上传中！');
            let typeStr = '';
            let typeStr2 = '';
            this.companyData.customer.forEach(item => (typeStr += item + ','));
            this.companyData.customer.forEach(item => {
              for (let i = 0; i < this.customerOption.length; i++) {
                if (item === this.customerOption[i].id) {
                  typeStr2 += this.customerOption[i].type_name + ',';
                  break;
                }
              }
            });
            let nameStr = '';
            let tellStr = '';
            let positionStr = '';
            this.companyData.person.forEach(item => {
              nameStr += item.name + ',';
              tellStr += item.tell + ',';
              positionStr += item.position + ',';
            });
            let fileStr = '';
            console.log(this.companyData.enclosure, 'this.companyData.enclosure');
            this.companyData.enclosure.forEach(item => {
              fileStr += item.response ? item.response.data.id + ',' : item.id + ',';
            });
            nameStr = nameStr[nameStr.length - 1] === ',' ? nameStr.slice(0, nameStr.length - 1) : nameStr;
            tellStr = tellStr[tellStr.length - 1] === ',' ? tellStr.slice(0, tellStr.length - 1) : tellStr;
            positionStr = positionStr[positionStr.length - 1] === ',' ? positionStr.slice(0, positionStr.length - 1) : positionStr;
            typeStr = typeStr[typeStr.length - 1] === ',' ? typeStr.slice(0, typeStr.length - 1) : typeStr;
            typeStr2 = typeStr2[typeStr2.length - 1] === ',' ? typeStr2.slice(0, typeStr2.length - 1) : typeStr2;
            fileStr = fileStr[fileStr.length - 1] === ',' ? fileStr.slice(0, fileStr.length - 1) : fileStr;
            const obj = {
              parentId: this.companyData.id,
              customerName: this.companyData.company,
              customerSimple: this.companyData.referred,
              keyWord: this.companyData.keyword,
              typeId: typeStr,
              typeName: typeStr2,
              isRisky: this.companyData.danger,
              //判断是否有公司性质
              customerNatureId: this.dialogTitle === '新增委托商' || this.dialogTitle === '修改委托商' ? (this.companyData.nature ? this.companyData.nature.id : '') : '',
              //判断是否有公司性质
              customerNatureName: this.dialogTitle === '新增委托商' || this.dialogTitle === '修改委托商' ? (this.companyData.nature ? this.companyData.nature.attrNm : '') : '',
              businessScope: this.companyData.scope,
              registeredCapital: this.companyData.registered,
              telephone: this.companyData.cTell,
              mailbox: this.companyData.mail,
              // address:this.companyData.address,
              //判断是否有公司规模
              customerScaleId: this.dialogTitle === '新增委托商' || this.dialogTitle === '修改委托商' ? (this.companyData.size ? this.companyData.size.id : '') : '',
              customerScaleName: this.dialogTitle === '新增委托商' || this.dialogTitle === '修改委托商' ? (this.companyData.size ? this.companyData.size.attrNm : '') : '',
              openAccountBank: this.companyData.bank,
              sellerTaxno: this.companyData.sellerTaxno,
              bankCardNumber: this.companyData.bankNo,
              businessSourceId: this.companyData.businessSourceId,
              customerIndustryId: this.companyData.customerIndustryId,
              // longitude:this.companyData.longitude,
              // latitude:this.companyData.latitude,
              directorName: nameStr,
              directorMobile: tellStr,
              directorPost: positionStr,
              explains: this.companyData.remark,
              attachmentIdStr: fileStr,
            };
            if (this.dialogTitle === '修改委托商') {
              this.btnLoading = true;
              obj.id = this.companyData.id;
              // this.formLoading = true; //等待接口加载 ，
              const res = await customerEdit(obj);
              // this.formLoading = false
              this.btnLoading = false;
              if (res.status !== 0) return this.$message.error(res.message);
              this.$message.success(res.message);
              this.dialogVisible = false;
              await this._customerInfoPageList();
            } else {
              this.btnLoading = true;
              // this.formLoading = true; //等待接口加载 ，
              const res = this.dialogTitle === '新增委托商' ? await customerAdd(obj) : await customerTypeInfoChange(obj);
              // this.formLoading = false
              this.btnLoading = false;
              if (res.status !== 0) return this.$message.error(res.message);
              this.$message.success(res.message);
              this.dialogVisible = false;
              await this._customerInfoPageList();
            }
          } else {
            return false;
          }
        });
      },
      beforeAvatarUpload(file) {
        const TypeArr = ['image/jpeg', 'image/png', 'image/bmp', 'image/gif', 'image/jpg', 'application/pdf', 'text/plain', 'application/x-zip-compressed', 'application/vnd.ms-excel', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'];
        const isJPG = TypeArr.includes(file.type);
        const isLt10M = file.size / 1024 / 1024 < 10;
        if (!isJPG) this.$message.error('上传附件格式不符合规范！');
        if (!isLt10M) this.$message.error('上传图片大小不能超过 10MB');
        this.btnLoading = true;
        return isJPG && isLt10M;
        // return isLt10M
      },
      uploadChange(file, fileList) {
        console.log(fileList, 'fileList11');
        if (this.uploadFlag) {
          this.companyData.enclosure.splice(this.uploadIndex, 1, file);
          this.uploadFlag = false;
        } else {
          this.companyData.enclosure = fileList;
        }
        if (Object.keys(file).includes('response')) {
          if (file.response.status !== 0) {
            this.companyData.enclosure.splice(this.companyData.enclosure.indexOf(file), 1);
          }
        }
      },
      handleRemove(item, index) {
        this.companyData.enclosure.splice(index, 1);
      },
      handlePictureCardPreview(file) {
        let token = getSessionStore('token');
        this.dialogImageUrl = baseImgUrl + '/web/attachmentFtp/download?attachmentId=' + (file.id || file.response.data.id) + '&access_token=' + token;

        console.log(this.dialogImageUrl);
        this.imgDialogVisible = true;
      },
      progress() {
        this.imgIsUpload = true;
      },
      success(res) {
        this.btnLoading = false;
        if (res.status !== 0) this.$message.error(res.message);
        this.$message.success(res.message);
        this.imgIsUpload = false;
      },
      //外部上传方法，替换
      uploadClick(item, index) {
        this.uploadIndex = index;
        this.uploadFlag = true;
        this.$refs.upload.$refs['upload-inner'].handleClick();
      },
    },
  };
</script>

<style lang="scss" scoped>
  .mainContainer {
    width: 100%;
    padding: 20px 15px 0 25px;
    background-color: #fff;

    .line {
      width: 12px;
      height: 32px;
      background-color: rgba(51, 84, 131, 100);
      margin-right: 10px;
    }

    .line + span {
      font-size: 16px;
      color: rgba(51, 84, 131, 100);
      font-weight: 600;
    }

    .nav {
      width: 100%;
      display: flex;
      align-items: center;
      flex-wrap: wrap;

      &Container {
        width: 200px;
        display: flex;
        align-items: center;
        margin-right: 5px;
        margin-bottom: 10px;

        p {
          font-size: 14px;
          color: rgba(16, 16, 16, 100);
        }
      }

      &Btn {
        display: flex;
        align-items: center;
        margin-bottom: 5px;
      }

      ::v-deep {
        label.el-form-item__label {
          font-weight: 500;
          color: #101010;
        }
      }
    }

    .content {
      display: flex;
      flex-direction: column;
      align-items: center;

      .tableContainer {
        margin-top: 10px;
        margin-bottom: 25px;
        width: 100%;

        ::v-deep {
          .el-loading-mask {
            z-index: 1000;
          }

          .el-badge__content {
            top: 4px !important;
            right: 1px !important;
          }

          .el-badge__content {
            background-color: #f56c6c !important;
          }

          .el-table .cell {
            padding: 0;
          }

          .el-table th {
            padding: 0;
          }

          .el-table td {
            padding: 0;
          }
        }

        &Nav {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: flex-end;

          span {
            color: rgba(51, 136, 255, 1);
            text-decoration: underline;
            margin-right: 10px;

            &:hover {
              cursor: pointer;
            }
          }
        }
      }

      .paginationContainer {
        margin-right: auto;
        display: flex;
        align-items: center;
        margin-bottom: 20px;

        span {
          font-size: 13px;
        }
      }
    }

    .depart {
      width: 100%;
      padding: 10px 40px 10px 10px;
      height: 75vh;
      overflow: auto;

      .specialSelect {
        ::v-deep {
          .el-input__inner {
            border: none;
          }
        }
      }

      .imgUp {
        .upload-demo {
          display: flex;
        }

        .upload {
          font-size: 17px;
          display: flex;
          align-items: center;
          justify-content: space-between;

          i {
            margin-right: 10px;
          }

          i:hover {
            color: #00e1ff;
          }
        }
      }

      ::v-deep {
        .el-form-item__label {
          font-weight: 700;
        }

        .el-form-item {
          margin-bottom: 13px;
        }

        .el-form-item__label {
          padding: 0;
        }

        .el-form-item__content {
          position: relative;
        }
      }

      .btnContainer {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 30px 0 10px 0;

        button {
          margin: 0 15px;
        }
      }
    }

    .permissions {
      width: 100%;
      padding: 20px 10px 20px 50px;

      .name {
        display: flex;
        align-items: center;
        margin-bottom: 20px;

        span {
          color: #2f1010;
        }
      }

      .content1 {
        p {
          color: #2f1010;
        }
      }

      .btnContainer {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 30px 0 10px 0;

        button {
          margin: 0 15px;
        }
      }
    }

    .cooperation {
      width: 100%;
      margin: 10px 20px;

      p {
        font-size: 14px;
        color: #606266;
        font-weight: 700;
        margin-bottom: 10px;
      }

      .btnContainer {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        padding-bottom: 20px;
      }
    }

    .detail {
      width: 100%;
      padding: 10px 0 20px 20px;
      max-height: 80vh;
      overflow: auto;

      ::v-deep {
        .el-badge__content {
          top: 4px !important;
          right: 1px !important;
        }

        .el-badge__content {
          background-color: #f56c6c !important;
        }
      }

      .baseInfo {
        display: flex;
        flex-direction: column;

        .attachment {
          display: flex;
          flex-direction: column;
          padding-top: 10px;

          &Item {
            width: 80%;
            margin-bottom: 10px;
            margin-left: 30px;
            display: flex;
            align-items: center;
            justify-content: space-between;

            span {
              color: #969696;
              font-size: 14px;
            }
          }
        }

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }

        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 23px;

          &Item {
            margin-bottom: 15px;

            .span1 {
              font-weight: 700;
            }

            span {
              font-size: 14px;
            }

            .specialOne {
              width: 50%;
            }
          }

          .specialItem {
            display: flex;
          }
        }
      }

      .operation {
        display: flex;
        flex-direction: column;

        ::v-deep {
          .el-table td,
          .el-table th {
            padding: 0;
          }

          .cell {
            font-size: 10px;
            padding: 0;
          }
        }

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }

        &Table {
          width: 100%;
          margin-top: 10px;
          padding: 0 20px;
        }
      }
    }

    ::v-deep {
      .tableContainerNav span i.el-icon-upload.el-icon--right {
        font-size: 16px;
        text-decoration: underline;
      }

      .el-table .ui-warning-row {
        background-color: #fef0f0 !important;
      }

      .el-table--enable-row-hover .el-table__body tr.ui-warning-row:hover > td {
        background-color: #fef0f0 !important;
      }

      .el-table .ui-warning-row .cell {
        color: red;
      }

      .el-dialog__header {
        padding: 9px 20px 9px;
        background: #335483;
      }

      .el-dialog__title {
        line-height: 24px;
        font-size: 14px;
        color: #ffffff;
      }

      .el-dialog__headerbtn {
        top: 9px;
      }

      .el-dialog__headerbtn .el-dialog__close {
        color: #fff;
        font-size: 25px;
      }

      .el-dialog__body {
        padding: 0;
      }
    }
  }
</style>
